import Spinner from "../../components/common/Spinner.jsx";

const Loading = () => {
  return (
    <div className="outer">
      <Spinner />
    </div>
  );
};

export default Loading;
